<article class="portrait-preview portrait-section__preview">
    <div class="box">
        <div class="box__content"><img class="portrait-preview__img" src="{{ injected.portraitBlurredImgUrl }}" alt="portrait preview (blurred)"></div>
    </div>
    <p class="portrait-preview__tip"><span class="text text_type_body-bold text_accented">Portrait revealed after mint</span></p>
</article>